import React from 'react';

/**
 * 웹은 메모리 게이팅(비활성 화면 콘텐츠 unmount)이 불필요/무의미하므로 no-op passthrough.
 * (네이티브 전용 최적화 — 네이티브 구현은 `InactiveScreenGate.tsx`)
 */
export const InactiveScreenGate = ({
  children,
}: {
  children: React.ReactNode;
}) => <>{children}</>;
